import React from "react";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SendEventType } from "../stateMachine/typings/SendEventType";
import { SpacerBottom } from "./SpacerBottom";

export interface Props {
  sendEvent: SendEventType;
}

export const ActivateOrDeactivate = ({ sendEvent }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h4" component="h1" mb={6}>
        {t("netfondsConsent.heading")}
      </Typography>

      <Typography variant="body1" mb={2}>
        {t("netfondsConsent.teaser")}
      </Typography>

      <Typography variant="body1" mb={8}>
        {t("netfondsConsent.description")}
      </Typography>

      <SpacerBottom spacing={2}>
        <Button
          variant="primary"
          onClick={() => sendEvent({ type: "BATCH_ACTIVATE" })}
        >
          {t("netfondsConsent.activateDataImport")}
        </Button>
      </SpacerBottom>
      <SpacerBottom spacing={4}>
        <Button
          variant="tertiary"
          onClick={() => sendEvent({ type: "BATCH_DEACTIVATE" })}
        >
          {t("netfondsConsent.doNotActivateDataImport")}
        </Button>
      </SpacerBottom>
    </>
  );
};
